import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { BRAND } from "../lib/constants";

export default function FloatingWhatsApp() {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 500);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <>
            {/* Floating WhatsApp (desktop) */}
            <AnimatePresence>
                {show && (
                    <motion.a
                        initial={{ opacity: 0, scale: 0.6 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.6 }}
                        transition={{ type: "spring", stiffness: 260, damping: 22 }}
                        href={BRAND.whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hidden md:flex fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white items-center justify-center pulse-ring hover:scale-105 transition-transform"
                        aria-label="Chat on WhatsApp"
                        data-testid="floating-whatsapp"
                    >
                        <MessageCircle size={24} strokeWidth={1.8} />
                    </motion.a>
                )}
            </AnimatePresence>

            {/* Mobile sticky CTA bar — premium card style */}
            <div
                className="md:hidden fixed bottom-0 inset-x-0 z-40 px-3 pb-3 pt-3 bg-gradient-to-t from-white via-white to-white/0 pointer-events-none"
                data-testid="mobile-sticky-cta"
            >
                <div className="pointer-events-auto flex items-center gap-2 bg-white rounded-2xl p-2 border border-black/5 shadow-[0_-8px_24px_rgba(0,0,0,0.06)]">
                    <a
                        href={`tel:${BRAND.phoneRaw}`}
                        className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-brand-bone text-brand-ink text-[13px] font-medium"
                        data-testid="mobile-call-cta"
                        aria-label="Call Dhanshree Constructions"
                    >
                        <Phone size={15} strokeWidth={2} />
                        Call
                    </a>
                    <a
                        href={BRAND.whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-1 flex items-center justify-center gap-2 brand-gradient text-white py-3 rounded-xl text-[14px] font-medium"
                        data-testid="mobile-whatsapp-cta"
                    >
                        <MessageCircle size={15} strokeWidth={2} />
                        Book Free Site Visit
                    </a>
                </div>
            </div>
        </>
    );
}
